import { snakeCase } from "@zetalabs/core";
import type { ParamValue } from "../client/types";

export function transformKeys(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any -- FIX: (bwilytsch) remove any later
	obj: Record<string, any>,
): Record<string, ParamValue> {
	const output: Record<string, ParamValue> = {};

	Object.keys(obj).forEach((key) => {
		output[snakeCase(key)] = obj[key] as ParamValue;
	});

	return output;
}
